import solanaPlugin from '@exodus/solana-plugin';
import solanaDevnetPlugin from '@exodus/solanadevnet-plugin';
import solanaTestnetPlugin from '@exodus/solanatestnet-plugin';
import { customizePlugin } from '../utils/customize-plugin.js';
const sharedConfig = {};
export const solana = customizePlugin({
    assetPlugin: solanaPlugin,
    config: sharedConfig,
});
export const solanadevnet = customizePlugin({
    assetPlugin: solanaDevnetPlugin,
    config: sharedConfig,
});
export const solanatestnet = customizePlugin({
    assetPlugin: solanaTestnetPlugin,
    config: sharedConfig,
});
